import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import BusComponent from '../BusComponent';
import Loader from '../Loader';
import DataBrowserHeader from './DataBrowserHeader';
import DATA_BROWSER_CONFIG from '../../helpers/DataBrowserConfig';
import DataBrowserContent from './DataBrowserContent';
import DataBrowserSearch from './DataBrowserSearch';

class DataBrowserWrapper extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            loading: false,
            currentMetadataSelection: undefined,
            openedGroups: [],
            dataset: null,
            searchText: '',
        };
    }

    componentDidMount() {
        this.bindGluBusEvents({
            METADATA_LOAD_SUCCESS: this.onMetadataLoadSuccess,
            METADATA_PERMISSIONS_UPDATED: this.onUpdateMetadata,
            MAP_NEW_DATA_THEME_APPLIED: this.onUpdateMetadata,
            DATASET_LOAD_SUCCESS: this.onDatasetLoadSuccess,
        });

        this.onUpdateMetadata();
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    onUpdateMetadata() {
        const { mapInstance } = this.props;

        this.bus.emit('METADATA_LOAD_REQUEST', {
            metadataGroupId: mapInstance.metadataGroupId,
            mapInstanceId: mapInstance.id,
            variableSelectionItems: mapInstance.dataTheme.variableSelection.items,
        });

        this.setState({
            loading: true,
        });
    }

    onMetadataLoadSuccess(eventMap) {
        const { mapInstance } = this.props;
        const { currentMetadataSelection } = eventMap;

        this.setState({
            currentMetadataSelection,
        });

        this.emit('DATASET_LOAD_REQUEST', {
            surveyName: DATA_BROWSER_CONFIG.survey,
            datasetName: DATA_BROWSER_CONFIG.dataset,
            mapInstanceId: mapInstance.id,
            source: this,
            includeVariables: true,
        });
    }

    onDatasetLoadSuccess = eventMap => {
        const { dataset } = eventMap;

        this.setState({
            dataset,
            loading: false,
        });
    };

    onSetOpenedGroup = group => {
        const { openedGroups } = this.state;

        const updatedGroups = [...openedGroups];
        const existingIndex = updatedGroups.findIndex(g => g.name === group.name);

        if (existingIndex !== -1) {
            updatedGroups.splice(existingIndex, 1);
        } else {
            updatedGroups.push(group);
        }

        this.setState({
            openedGroups: updatedGroups,
        });
    };

    onSearchTextChange = searchText => {
        this.setState({
            searchText,
        });
    };

    renderContent() {
        const { loading, dataset, currentMetadataSelection, openedGroups, searchText } = this.state;
        const { mapInstance } = this.props;

        if (loading || !dataset) {
            return (
                <div className="grow flex-it center justify-center">
                    <Loader
                        text={this.props.intl.formatMessage({
                            id: 'variablePicker.gettingMetadata',
                        })}
                    />
                </div>
            );
        }

        return (
            <div className="data-browser__content-wrapper">
                <DataBrowserContent
                    mapInstance={mapInstance}
                    dataset={dataset}
                    currentMetadataSelection={currentMetadataSelection}
                    openedGroups={openedGroups}
                    onSetOpenedGroup={this.onSetOpenedGroup}
                    searchText={searchText}
                />
            </div>
        );
    }

    render() {
        const { className, onClose } = this.props;
        const { searchText, loading } = this.state;

        const dataBrowserClassNames = classNames(
            'data-browser__wrapper data-browser__popup',
            className,
        );

        return (
            <div className={dataBrowserClassNames}>
                <DataBrowserHeader onClose={onClose} />
                {!loading && (
                    <DataBrowserSearch searchText={searchText} onChange={this.onSearchTextChange} />
                )}
                {this.renderContent()}
            </div>
        );
    }
}

DataBrowserWrapper.propTypes = {
    mapInstance: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
};

DataBrowserWrapper.defaultProps = {};

export default injectIntl(DataBrowserWrapper);
